goog.provide("shadow.js.shim.module$$mui$material$AccordionDetails$default");
shadow.js.shim.module$$mui$material$AccordionDetails$default = shadow.js.shim.module$$mui$material$AccordionDetails.default;
